var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExamNonSelectedCu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Exam - Default",
    clipPath: "url(#clip0_2107_38229)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 6236",
    d: "M13 5V2.55556C13 2.35128 12.9591 2.149 12.8797 1.96027C12.8002 1.77154 12.6838 1.60006 12.537 1.45561C12.3902 1.31116 12.216 1.19658 12.0242 1.11841C11.8324 1.04024 11.6268 1 11.4192 1H2.58077C2.16152 1 1.75945 1.16389 1.463 1.45561C1.16654 1.74733 1 2.143 1 2.55556V13.4444C1 13.857 1.16654 14.2527 1.463 14.5444C1.75945 14.8361 2.16152 15 2.58077 15H5",
    stroke: "#999899",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 6238",
    d: "M4 4.5H10",
    stroke: "#999899",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 6239",
    d: "M4 7H10",
    stroke: "#999899",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 6240",
    d: "M4 9.5H8",
    stroke: "#999899",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 6237",
    d: "M15.4759 10.7007L11.7265 14.4539L9 15L9.54551 12.2707L13.295 8.51749C13.4353 8.36057 13.6061 8.23385 13.7969 8.14501C13.9877 8.05618 14.1946 8.00708 14.4049 8.00071C14.6152 7.99434 14.8247 8.03082 15.0205 8.10795C15.2163 8.18507 15.3944 8.30123 15.544 8.44936C15.694 8.598 15.8119 8.77596 15.8902 8.97218C15.9686 9.16839 16.0057 9.37865 15.9993 9.58985C15.9929 9.80105 15.9432 10.0087 15.8531 10.1998C15.7631 10.3909 15.6347 10.5614 15.4759 10.7007Z",
    stroke: "#999899",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 419",
    x1: 12.4243,
    y1: 8.57574,
    x2: 15.4243,
    y2: 11.5757,
    stroke: "#999899",
    strokeWidth: 1.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2107_38229"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExamNonSelectedCu);
export default __webpack_public_path__ + "static/media/icon-exam-non-selected-cu.cb9ef11e755ab46f9a3070ad871a910a.svg";
export { ForwardRef as ReactComponent };